import tg from "./tg.png";
import vk from "./vk.png";
import vkIcon from "./vkIcon.png";
import tgIcon from "./tgIcon.png";

export const socialNetworkImages = [
  { img: vk, alt: "VKontakte", icon: vkIcon, link: "https://vk.com/oceanbasket_ru" },
  { img: tg, alt: "Telegram", icon: tgIcon, link: "https://t.me/oceanbasket_ru" }
];
